import http from "./http-common";

class WorkOrganisationService {
   
    
    async getJobPositionWorkTasks(jobPositionId) {
        const response = await http.get("/WorkOrganisation/GetJobPositionWorkTasks?jobPositionId=" + jobPositionId);
        var data = response.data;
        return data;
    }

    async getJobPositionBaseBlockWorkTasks(jobPositionId) {
        const response = await http.get("/WorkOrganisation/GetJobPositionBaseBlockWorkTasks?jobPositionId=" + jobPositionId);
        var data = response.data;
        return data;
    }

    async getWorkSuggestions() {
        const response = await http.get("/WorkOrganisation/getWorkSuggestions");
        var data = response.data;
        return data;
    }

    async setRegulation(content, type) {
        let formData = new FormData();
        formData.append('content', content);
        formData.append('type', type);
        let config = { headers: { 'Content-Type': 'multipart/form-data' } }
        const response = await http.post("/WorkOrganisation/setRegulation", formData, config);
        var data = response.data;
        return data;
    }

    async getRegulation(type) {
        const response = await http.get("/WorkOrganisation/getRegulation?type=" + type);
        var data = response.data;
        return data;
    }

    async addJobPosition(name) {
        const query = new URLSearchParams({ name: name ?? "" });
        const response = await http.get("/WorkOrganisation/AddJobPosition?" + query.toString());
        var data = response.data;
        return data;
    }

    async deleteJobPosition(jobPositionId) {
        const response = await http.get("/WorkOrganisation/DeleteJobPosition?jobPositionId=" + jobPositionId);
        var data = response.data;
        return data;
    }

    async updateBlock(blockid, name, blocknumber) {
        const response = await http.get("/WorkOrganisation/updateBlock?blockid=" + blockid + "&name=" + name + "&blocknumber=" + blocknumber);
        var data = response.data;
        return data;
    }

    async updateJobPosition(jobPositionId, name, referencePosition) {
        const query = new URLSearchParams({
            jobPositionId: String(jobPositionId),
            name: name ?? "",
            referencePosition: String(referencePosition),
        });
        const response = await http.get("/WorkOrganisation/UpdateJobPosition?" + query.toString());
        var data = response.data;
        return data;
    }

    async getJobPositions() {
        const response = await http.get("/WorkOrganisation/GetJobPositions" );
        var data = response.data;
        return data;
    }

    async getJobPositionWithPointSum() {
        const response = await http.get("/WorkOrganisation/GetJobPositionWithPointSum");
        var data = response.data;
        return data;
    }

    async addJobPositionTask(jobPositionId, name, educationAndRequirements, comments) {
        let formData = new FormData();
        formData.append('jobPositionId', jobPositionId);
        formData.append('name', name);
        formData.append('educationAndRequirements', educationAndRequirements);
        formData.append('comments', comments);
        let config = { headers: { 'Content-Type': 'multipart/form-data' } }
        const response = await http.post("/WorkOrganisation/AddJobPositionTask", formData, config);
        var data = response.data;
        return data;
    }

    async addJobPositionTaskSuggestion(name, educationAndRequirements) {
        let formData = new FormData();
        formData.append('name', name);
        formData.append('educationAndRequirements', educationAndRequirements);
        let config = { headers: { 'Content-Type': 'multipart/form-data' } }
        const response = await http.post("/WorkOrganisation/AddJobPositionTaskSuggestion", formData, config);
        var data = response.data;
        return data;
    }
    async copyJobPositionTaskToSuggestion(taskId) {
        const response = await http.get("/WorkOrganisation/CopyJobPositionTaskToSuggestion?taskId=" + taskId)
        var data = response.data;
        return data;
    }
    
    async updateJobPositionTask(jobPositionTaskId, name, educationAndRequirements, comments) {
        let formData = new FormData();
        formData.append('jobPositionTaskId', jobPositionTaskId);
        formData.append('name', name);
        formData.append('educationAndRequirements', educationAndRequirements);
        formData.append('comments', comments);
        let config = { headers: { 'Content-Type': 'multipart/form-data' } }
        const response = await http.post("/WorkOrganisation/updateJobPositionTask", formData, config);
        var data = response.data;
        return data;
    }

    async deleteJobPositionWorkTask(jobPositionTaskId) {
        const response = await http.get("/WorkOrganisation/DeleteJobPositionTask?jobPositionTaskId=" + jobPositionTaskId);
        var data = response.data;
        return data;
    }

    async deleteJobPositionWorkTaskSuggestion(jobPositionTaskId) {
        const response = await http.get("/WorkOrganisation/DeleteJobPositionTaskSuggestion?jobPositionTaskId=" + jobPositionTaskId);
        var data = response.data;
        return data;
    }

    async updateJobPositionTaskSuggestion(jobPositionTaskId, name, educationAndRequirements) {
        let formData = new FormData();
        formData.append('jobPositionTaskId', jobPositionTaskId);
        formData.append('name', name);
        formData.append('educationAndRequirements', educationAndRequirements);
        let config = { headers: { 'Content-Type': 'multipart/form-data' } }
        const response = await http.post("/WorkOrganisation/UpdateJobPositionTaskSuggestion", formData, config);
        var data = response.data;
        return data;
    }

    async addJobPositionDevelopmentBlock(jobPositionId, name, blockNumber) {
        let formData = new FormData();
        formData.append('jobPositionId', jobPositionId);
        formData.append('name', name);
        formData.append('blockNumber', blockNumber);
        let config = { headers: { 'Content-Type': 'multipart/form-data' } }
        const response = await http.post("/WorkOrganisation/AddJobPositionDevelopmentBlock", formData, config);
        var data = response.data;
        return data;
    }

    async deleteJobPositionDevelopmentBlock(jobPositionBlockId) {
        const response = await http.get("/WorkOrganisation/DeleteJobPositionDevelopmentBlock?jobPositionBlockId=" + jobPositionBlockId);
        var data = response.data;
        return data;
    }

    async getJobPositionblocks(jobPositionId, excludebase = false) {
        const response = await http.get("/WorkOrganisation/getJobPositionblocks?jobPositionId=" + jobPositionId + "&excludebase=" + excludebase);
        var data = response.data;
        return data;
    }

    async getJobPositionBlocksPointSumAll(jobPositionId) {
        const response = await http.get("/WorkOrganisation/GetJobPositionBlocksPointSumAll?jobPositionId=" + jobPositionId);
        var data = response.data;
        return data;
    }

    async getJobPositionsWithBlocks(excludeBase = true) {
        const response = await http.get("/WorkOrganisation/GetJobPositionsWithBlocks?excludeBase=" + excludeBase);
        var data = response.data;
        return data;
    }

    async getJobPositionsWithEmployees() {
        const response = await http.get("/WorkOrganisation/getJobPositionsWithEmployees");
        var data = response.data;
        return data;
    }

    async getEmployeesWithIndividualFactors(jobPositionId) {
        const response = await http.get("/WorkOrganisation/GetEmployeesWithIndividualFactors?jobPositionId=" + jobPositionId);
        var data = response.data;
        return data;
    }


    async saveJobPositionblocks(tasks) {
        const response = await http.post("/WorkOrganisation/SaveJobPositionDevelopmentBlocks", JSON.stringify(tasks));
        var data = response.data;
        return data;
    }

    async ping() {
        const response = await http.get("/Ping/ping");
        var data = response.data;
        return data;
    }
    
}

export default new WorkOrganisationService();
